import React from 'react';
import { 
  HelpCircle, 
  Droplet, 
  Clock, 
  AlertTriangle, 
  Coffee, 
  Utensils, 
  ThermometerSun, 
  Activity 
} from 'lucide-react';

/**
 * Компонент с полезными советами о потреблении воды
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Clock,
      title: 'Оптимальное время',
      description: 'Выпивайте стакан воды сразу после пробуждения, чтобы запустить метаболизм и восполнить ночную потерю влаги.'
    },
    {
      icon: Droplet,
      title: 'Качество воды',
      description: 'Для ежедневного потребления рекомендуется очищенная или фильтрованная вода без газа.'
    },
    {
      icon: Activity,
      title: 'При физических нагрузках',
      description: 'Во время тренировки пейте небольшими порциями каждые 15-20 минут, а не много за один раз.'
    },
    {
      icon: ThermometerSun,
      title: 'В жаркую погоду',
      description: 'Увеличьте потребление воды на 500-1000 мл в жаркие дни для компенсации потери влаги с потом.'
    },
    {
      icon: AlertTriangle,
      title: 'Признаки обезвоживания',
      description: 'Сухость во рту, темная моча, усталость, головокружение могут быть признаками недостатка воды в организме.'
    },
    {
      icon: Coffee,
      title: 'Кофе и чай',
      description: 'Кофеинсодержащие напитки обладают мочегонным эффектом. На каждую чашку кофе выпивайте дополнительный стакан воды.'
    },
    {
      icon: Utensils,
      title: 'Вода в продуктах',
      description: 'Огурцы, арбузы, клубника, апельсины и салат содержат более 90% воды и помогают поддерживать водный баланс.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-blue-500" />
        Полезные советы
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <Droplet className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Знаете ли вы?
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Более 60% тела взрослого человека состоит из воды. Регулярное 
              потребление достаточного количества воды важно для поддержания 
              всех функций организма, включая пищеварение, транспорт питательных 
              веществ, терморегуляцию и выведение токсинов.
            </p>
            <a 
              href="#"
              className="inline-block w-full py-1.5 text-xs text-center bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
            >
              Подробнее о важности воды
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;